import { Bubble, Props } from './Bubble';

export const CanceledBubble = (props: Props) => (
  <Bubble {...props}>
    <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
      <p className="leading-5 text-white">
        繋がりませんでした
        <br />
        {props.message.text}
      </p>
    </div>
  </Bubble>
);
